module.exports = __webpack_public_path__ + "static/img/Ht.518ae338.png";